module.exports = __webpack_public_path__ + "static/img/solutionAdvantageIcon02.4a1560b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionAdvantageIcon02.png
// module id = C2rJ
// module chunks = 0